module.exports = __webpack_public_path__ + "img/bb_g3_nose-01.edbfcd13.svg";